import { render, staticRenderFns } from "./UserSettings.vue?vue&type=template&id=73ca221c&scoped=true&"
import script from "./UserSettings.vue?vue&type=script&lang=ts&"
export * from "./UserSettings.vue?vue&type=script&lang=ts&"
import style0 from "./UserSettings.vue?vue&type=style&index=0&id=73ca221c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ca221c",
  null
  
)

export default component.exports